export default __webpack_public_path__ + "static/media/ticket_purchase_pc@2x.64d8c5ae.jpg";